export default __webpack_public_path__ + "static/media/atarudpng.1b15a082.jpg";